import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  private useDisaster = false;

  getVersion() {
    return 'v3.3.60';
  }

  getShopifyApp(): string {
    return 'https://paylinkapp.paylink.sa';
  }

  getRegister(): string {
    const serverUrl = window.location.href;
    if (serverUrl.indexOf('sandbox.paylink.aws.salla.group') > -1) {
      return 'https://register.sandbox.paylink.aws.salla.group';
    }
    return 'https://register.paylink.sa';
  }

  getRest(): string {
    if (this.useDisaster) {
      return 'https://reststage.paylink.biz';
    }
    let serverUrl = window.location.href;
    if (serverUrl.indexOf('localhost') > -1) {
      return 'http://localhost:8085';
    } else if (window.location.hostname === 'my.sandbox.paylink.sa') {
      return 'https://restapi.sandbox.paylink.sa';
    } else if (serverUrl.indexOf('sandbox.paylink.aws.salla.group') > -1) {
      return 'https://restapi.sandbox.paylink.aws.salla.group';
    } else if (serverUrl.indexOf('https://paylink.sa') > -1) {
      return 'https://restapi.paylink.sa';
    } else if (serverUrl.indexOf('https://paylink.page') > -1) {
      return 'https://restapi.paylink.page';
    } else if (serverUrl.indexOf('paylink.biz') > -1) {
      return 'https://restapi.paylink.biz';
    } else if (serverUrl.indexOf('ngrok') > -1) {
      return 'https://paylinkapi.eu.ngrok.io';
    } else if (serverUrl.indexOf('172.20.10.8') > -1) {
      return 'https://paylinkapi.eu.ngrok.io';
    } else if (serverUrl.indexOf('stage') > -1) {
      return 'https://reststage.paylink.sa';
    } else if (serverUrl.indexOf('pilot') > -1) {
      return 'https://restpilot.paylink.sa';
    } else if (serverUrl.indexOf('testweb') > -1) {
      return 'https://testapi.paylink.sa';
    } else if (serverUrl.indexOf('test.paylink.sa') > -1) {
      return 'https://resttest.paylink.sa';
    } else {
      return 'https://restapi.paylink.sa';
    }
  }

  getDesktop(): string {
    let serverUrl = window.location.href;
    if (serverUrl.indexOf('localhost') > -1) {
      return 'http://localhost:4201';
    } else if (window.location.hostname === 'my.sandbox.paylink.sa') {
      return 'https://my.sandbox.paylink.sa';
    } else if (serverUrl.indexOf('sandbox.paylink.aws.salla.group') > -1) {
      return 'https://my.sandbox.paylink.aws.salla.group';
    } else if (serverUrl.indexOf('https://paylink.sa') > -1) {
      return 'https://my.paylink.sa';
    } else if (serverUrl.indexOf('https://paylink.page') > -1) {
      return 'https://my.paylink.page';
    } else if (serverUrl.indexOf('paylink.biz') > -1) {
      return 'https://my.paylink.biz';
    } else if (serverUrl.indexOf('ngrok') > -1) {
      return 'https://mypaylink.eu.ngrok.io';
    } else if (serverUrl.indexOf('stage') > -1) {
      return 'https://mystage.paylink.sa';
    } else if (serverUrl.indexOf('pilot') > -1) {
      return 'https://mypilot.paylink.sa';
    } else if (serverUrl.indexOf('testweb') > -1) {
      return 'https://mytest.paylink.sa';
    } else if (serverUrl.indexOf('test.paylink.sa') > -1) {
      return 'https://mytest.paylink.sa';
    } else {
      return 'https://my.paylink.sa';
    }
  }

  getPaymentWebUrl(): string {
    let serverUrl = window.location.href;
    if (serverUrl.indexOf('localhost') > -1) {
      return 'http://localhost:4200';
    } else if (window.location.hostname === 'my.sandbox.paylink.sa') {
      return 'https://payment.sandbox.paylink.sa';
    } else if (serverUrl.indexOf('sandbox.paylink.aws.salla.group') > -1) {
      return 'https://payment.sandbox.paylink.aws.salla.group';
    } else if (serverUrl.indexOf('https://paylink.sa') > -1) {
      return 'https://payment.paylink.sa';
    } else if (serverUrl.indexOf('https://payment.paylink.sa') > -1) {
      return 'https://payment.paylink.sa';
    } else if (serverUrl.indexOf('https://paymentlive.paylink.sa') > -1) {
      return 'https://payment.paylink.sa';
    } else if (serverUrl.indexOf('https://paylink.page') > -1) {
      return 'https://payment.paylink.page';
    } else if (serverUrl.indexOf('https://paylink.biz') > -1) {
      return 'https://payment.paylink.biz';
    } else if (serverUrl.indexOf('ngrok') > -1) {
      return 'https://paylinkpay.eu.ngrok.io';
    } else if (serverUrl.indexOf('172.20.10') > -1) {
      return 'https://paylinkpay.eu.ngrok.io';
    } else if (serverUrl.indexOf('stage') > -1) {
      return 'https://paymentstage.paylink.sa';
    } else if (serverUrl.indexOf('pilot.paylink.biz') > -1) {
      return 'https://paymentpilot.paylink.biz';
    } else if (serverUrl.indexOf('paymentpilot') > -1) {
      return 'https://paymentpilot.paylink.sa';
    } else if (serverUrl.indexOf('pilot') > -1) {
      return 'https://paymentpilot.paylink.sa';
    } else if (serverUrl.indexOf('test.paylink.sa') > -1) {
      return 'https://paymenttest.paylink.sa';
    } else {
      return 'https://payment.paylink.sa';
    }
  }

  getWeb(): string {
    let serverUrl = window.location.href;
    if (serverUrl.indexOf('localhost') > -1) {
      return 'https://paylinkng.eu.ngrok.io';
    } else if (window.location.hostname === 'my.sandbox.paylink.sa') {
      return 'https://sandbox.paylink.sa';
    } else if (serverUrl.indexOf('sandbox.paylink.aws.salla.group') > -1) {
      return 'https://sandbox.paylink.aws.salla.group';
    } else if (serverUrl.indexOf('https://paylink.sa') > -1) {
      return 'https://paylink.sa';
    } else if (serverUrl.indexOf('https://paylink.page') > -1) {
      return 'https://paylink.page';
    } else if (serverUrl.indexOf('paylink.biz') > -1) {
      return 'https://paylink.biz';
    } else if (serverUrl.indexOf('ngrok') > -1) {
      return 'https://paylinkng.eu.ngrok.io';
    } else if (serverUrl.indexOf('172.20.10') > -1) {
      return 'https://paylinkng.eu.ngrok.io';
    } else if (serverUrl.indexOf('stage') > -1) {
      return 'https://stage.paylink.sa';
    } else if (serverUrl.indexOf('pilot') > -1) {
      return 'https://pilot.paylink.sa';
    } else if (serverUrl.indexOf('testweb') > -1) {
      return 'https://testweb.paylink.sa';
    } else if (serverUrl.indexOf('test.paylink.sa') > -1) {
      return 'https://test.paylink.sa';
    } else {
      return 'https://paylink.sa';
    }
  }

  getStoreUrl(): string {
    let serverUrl = window.location.href;
    if (serverUrl.indexOf('localhost') > -1) {
      return 'http://localhost:4203/';
    } else if (window.location.hostname === 'my.sandbox.paylink.sa') {
      return 'https://store.sandbox.paylink.sa/';
    } else if (serverUrl.indexOf('sandbox.paylink.aws.salla.group') > -1) {
      return 'https://store.sandbox.paylink.aws.salla.group/';
    } else if (serverUrl.indexOf('https://paylink.sa') > -1) {
      return 'https://store.paylink.sa/';
    } else if (serverUrl.indexOf('https://paylink.page') > -1) {
      return 'https://store.paylink.page/';
    } else if (serverUrl.indexOf('paylink.biz') > -1) {
      return 'https://store.paylink.biz/';
    } else if (serverUrl.indexOf('ngrok') > -1) {
      return 'http://localhost:4203/';
    } else if (serverUrl.indexOf('172.20.10') > -1) {
      return 'http://172.20.10.8:4203/';
    } else if (serverUrl.indexOf('stage') > -1) {
      return 'https://storestage.paylink.sa/';
    } else if (serverUrl.indexOf('pilot') > -1) {
      return 'https://storepilot.paylink.sa/';
    } else if (serverUrl.indexOf('test.paylink.sa') > -1) {
      return 'https://storetest.paylink.sa/';
    } else {
      return 'https://store.paylink.sa/';
    }
  }

  checkPermission(accountType: any, govId: any) {
    if (accountType != null) {
      return {
        isAccountant: accountType.includes('Accountant') || false,
        isSales: accountType.includes('Sales') || (govId != null && false),
        isManager: accountType.includes('Manager') || false,
        isMerchant: govId == null
      };
    } else {
      return {
        isAccountant: false,
        isSales: (govId != null && accountType == null),
        isManager: false,
        isMerchant: govId == null
      };
    }
  }
}
